const config = {
  mapboxToken: process.env.REACT_APP_MAPBOX_TOKEN,
  mapStyle: 'mapbox://styles/mapbox/streets-v12',
};

export default config;
